module.exports = __webpack_public_path__ + "static/media/view_white.85c8ef10.svg";